/** @jsx jsx */

import { Fragment as _, useContext, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import Slider from './Slider';
import EditableBtn from 'components/lib/EditableBtn';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Feedback from 'components/lib/Feedback/Feedback_updated_022022';
import { ImageContext } from 'components/lib/Image';
import CC_QuestionTextImage from 'assets/CC_QuestionTextImage.svg';
import Embed from 'components/lib/Embed';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Slider,
  Text: EditableText,
  // Image,
  Image: ({ children, ...props }) => {
    return (
      <Image
        {...{
          ...props,
          placeholder: imgPlaceholders[1],
        }}
      />
    );
  },
  TwoColumnLayout,
  SingleColumnLayout,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [slider, txt] = children;

    if (!includeAdditionalTextField) {
      return slider;
    }

    return (
      <_>
        {slider}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  ColumnContent: ({ children, ...props }) => {
    const { includeQuestionTextPlusImage } = useContext(
      InteractionContext
    )?.props;

    const [img, txt] = children;

    return includeQuestionTextPlusImage ? (
      <ImageContext.Provider
        value={{
          placeholder: CC_QuestionTextImage,
        }}
      >
        {img}
      </ImageContext.Provider>
    ) : (
      txt
    );
  },
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
  EditableButton: EditableBtn,
  Audio,
  Embed,
  Transcript: ({ children, props }) => {
    return children;
  },
  Feedback,
  Correct: ({ children, props }) => children,
  Incorrect: ({ children, props }) => children,
  Attempt: ({ children, props }) => children,
  PDF,
  OpenPDF,
};

// memo(
const SliderDisplay = (props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
};
//, shouldUpdate as any);

export default SliderDisplay;
